import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { commentsApi } from "@/features/tasks/api/comments";

const commentKeys = {
  list: (taskId: string) => ["comments", taskId] as const,
};

export function useTaskComments(taskId: string) {
  return useQuery({
    queryKey: commentKeys.list(taskId),
    queryFn: () => commentsApi.list(taskId),
    enabled: !!taskId,
  });
}

export function useCreateComment(taskId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ content, mentionIds, replyTo }: { content: string; mentionIds?: string[]; replyTo?: string | null }) =>
      commentsApi.create(taskId, content, mentionIds, replyTo),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: commentKeys.list(taskId) });
    },
  });
}

export function useUpdateComment(taskId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, content, mentionIds }: { id: string; content: string; mentionIds?: string[] }) =>
      commentsApi.update(taskId, id, content, mentionIds),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: commentKeys.list(taskId) });
    },
  });
}

export function useDeleteComment(taskId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => commentsApi.delete(taskId, id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: commentKeys.list(taskId) });
    },
  });
}
